/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as DesktopResetPasswordRouteImport } from './routes/desktop/reset-password'
import { Route as DesktopAuthorizeRouteImport } from './routes/desktop/authorize'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AppGettingStartedRouteImport } from './routes/_app/getting-started'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAcceptInviteRouteImport } from './routes/_app/accept-invite'
import { Route as AppWorkspaceRouteImport } from './routes/_app/$workspace'
import { Route as AppGettingStartedIndexRouteImport } from './routes/_app/getting-started/index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminWorkflowsRouteImport } from './routes/_app/admin/workflows'
import { Route as AppAdminWaitlistRouteImport } from './routes/_app/admin/waitlist'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppAdminSandboxesRouteImport } from './routes/_app/admin/sandboxes'
import { Route as AppAdminImplementationsRouteImport } from './routes/_app/admin/implementations'
import { Route as AppAcceptInviteTokenRouteImport } from './routes/_app/accept-invite/$token'
import { Route as AppWorkspaceSettingsRouteImport } from './routes/_app/$workspace/settings'
import { Route as AppWorkspaceDashboardRouteImport } from './routes/_app/$workspace/_dashboard'
import { Route as AppAdminWorkflowsIndexRouteImport } from './routes/_app/admin/workflows/index'
import { Route as AppAdminSandboxesIndexRouteImport } from './routes/_app/admin/sandboxes/index'
import { Route as AppAdminImplementationsIndexRouteImport } from './routes/_app/admin/implementations/index'
import { Route as AppWorkspaceSettingsIndexRouteImport } from './routes/_app/$workspace/settings/index'
import { Route as AppWorkspaceDashboardIndexRouteImport } from './routes/_app/$workspace/_dashboard/index'
import { Route as AppAdminWorkflowsIdRouteImport } from './routes/_app/admin/workflows/$id'
import { Route as AppAdminSandboxesNameRouteImport } from './routes/_app/admin/sandboxes/$name'
import { Route as AppAdminImplementationsIdRouteImport } from './routes/_app/admin/implementations/$id'
import { Route as AppWorkspaceSettingsWorkspaceRouteImport } from './routes/_app/$workspace/settings/workspace'
import { Route as AppWorkspaceSettingsTagsRouteImport } from './routes/_app/$workspace/settings/tags'
import { Route as AppWorkspaceSettingsSecretsRouteImport } from './routes/_app/$workspace/settings/secrets'
import { Route as AppWorkspaceSettingsRiskRouteImport } from './routes/_app/$workspace/settings/risk'
import { Route as AppWorkspaceSettingsPlansRouteImport } from './routes/_app/$workspace/settings/plans'
import { Route as AppWorkspaceSettingsMembersRouteImport } from './routes/_app/$workspace/settings/members'
import { Route as AppWorkspaceSettingsKnowledgeRouteImport } from './routes/_app/$workspace/settings/knowledge'
import { Route as AppWorkspaceSettingsFrictionRouteImport } from './routes/_app/$workspace/settings/friction'
import { Route as AppWorkspaceSettingsBillingRouteImport } from './routes/_app/$workspace/settings/billing'
import { Route as AppWorkspaceDashboardSearchRouteImport } from './routes/_app/$workspace/_dashboard/search'
import { Route as AppWorkspaceSettingsIntegrationsIndexRouteImport } from './routes/_app/$workspace/settings/integrations/index'
import { Route as AppWorkspaceSettingsAccountIndexRouteImport } from './routes/_app/$workspace/settings/account/index'
import { Route as AppWorkspaceDashboardTasksIndexRouteImport } from './routes/_app/$workspace/_dashboard/tasks/index'
import { Route as AppWorkspaceDashboardSessionsIndexRouteImport } from './routes/_app/$workspace/_dashboard/sessions/index'
import { Route as AppWorkspaceDashboardKnowledgeIndexRouteImport } from './routes/_app/$workspace/_dashboard/knowledge/index'
import { Route as AppWorkspaceDashboardInsightsIndexRouteImport } from './routes/_app/$workspace/_dashboard/insights/index'
import { Route as AppWorkspaceDashboardImplementationsIndexRouteImport } from './routes/_app/$workspace/_dashboard/implementations/index'
import { Route as AppWorkspaceDashboardFrictionIndexRouteImport } from './routes/_app/$workspace/_dashboard/friction/index'
import { Route as AppWorkspaceDashboardBriefsIndexRouteImport } from './routes/_app/$workspace/_dashboard/briefs/index'
import { Route as AppWorkspaceDashboardAutomationsIndexRouteImport } from './routes/_app/$workspace/_dashboard/automations/index'
import { Route as AppWorkspaceSettingsIntegrationsSupabaseRouteImport } from './routes/_app/$workspace/settings/integrations/supabase'
import { Route as AppWorkspaceSettingsIntegrationsSentryRouteImport } from './routes/_app/$workspace/settings/integrations/sentry'
import { Route as AppWorkspaceSettingsIntegrationsNeonRouteImport } from './routes/_app/$workspace/settings/integrations/neon'
import { Route as AppWorkspaceSettingsIntegrationsMcpSetupRouteImport } from './routes/_app/$workspace/settings/integrations/mcp-setup'
import { Route as AppWorkspaceSettingsIntegrationsLinearRouteImport } from './routes/_app/$workspace/settings/integrations/linear'
import { Route as AppWorkspaceSettingsIntegrationsGithubRouteImport } from './routes/_app/$workspace/settings/integrations/github'
import { Route as AppWorkspaceSettingsIntegrationsClaudeCodeRouteImport } from './routes/_app/$workspace/settings/integrations/claude-code'
import { Route as AppWorkspaceSettingsAccountProfileRouteImport } from './routes/_app/$workspace/settings/account/profile'
import { Route as AppWorkspaceSettingsAccountPreferencesRouteImport } from './routes/_app/$workspace/settings/account/preferences'
import { Route as AppWorkspaceSettingsAccountConnectionsRouteImport } from './routes/_app/$workspace/settings/account/connections'
import { Route as AppWorkspaceSettingsAccountApiRouteImport } from './routes/_app/$workspace/settings/account/api'
import { Route as AppWorkspaceDashboardTasksIdRouteImport } from './routes/_app/$workspace/_dashboard/tasks/$id'
import { Route as AppWorkspaceDashboardSessionsIdRouteImport } from './routes/_app/$workspace/_dashboard/sessions/$id'
import { Route as AppWorkspaceDashboardKnowledgeIdRouteImport } from './routes/_app/$workspace/_dashboard/knowledge/$id'
import { Route as AppWorkspaceDashboardImplementationsIdRouteImport } from './routes/_app/$workspace/_dashboard/implementations/$id'
import { Route as AppWorkspaceDashboardBriefsIdRouteImport } from './routes/_app/$workspace/_dashboard/briefs/$id'
import { Route as AppWorkspaceDashboardAutomationsNewRouteImport } from './routes/_app/$workspace/_dashboard/automations/new'
import { Route as AppWorkspaceDashboardAutomationsIdIndexRouteImport } from './routes/_app/$workspace/_dashboard/automations/$id.index'
import { Route as AppWorkspaceDashboardAutomationsIdEditRouteImport } from './routes/_app/$workspace/_dashboard/automations/$id.edit'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const DesktopResetPasswordRoute = DesktopResetPasswordRouteImport.update({
  id: '/desktop/reset-password',
  path: '/desktop/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopAuthorizeRoute = DesktopAuthorizeRouteImport.update({
  id: '/desktop/authorize',
  path: '/desktop/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppGettingStartedRoute = AppGettingStartedRouteImport.update({
  id: '/getting-started',
  path: '/getting-started',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAcceptInviteRoute = AppAcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkspaceRoute = AppWorkspaceRouteImport.update({
  id: '/$workspace',
  path: '/$workspace',
  getParentRoute: () => AppRoute,
} as any)
const AppGettingStartedIndexRoute = AppGettingStartedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppGettingStartedRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminWorkflowsRoute = AppAdminWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminWaitlistRoute = AppAdminWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSandboxesRoute = AppAdminSandboxesRouteImport.update({
  id: '/sandboxes',
  path: '/sandboxes',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminImplementationsRoute = AppAdminImplementationsRouteImport.update({
  id: '/implementations',
  path: '/implementations',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAcceptInviteTokenRoute = AppAcceptInviteTokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => AppAcceptInviteRoute,
} as any)
const AppWorkspaceSettingsRoute = AppWorkspaceSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppWorkspaceRoute,
} as any)
const AppWorkspaceDashboardRoute = AppWorkspaceDashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => AppWorkspaceRoute,
} as any)
const AppAdminWorkflowsIndexRoute = AppAdminWorkflowsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminWorkflowsRoute,
} as any)
const AppAdminSandboxesIndexRoute = AppAdminSandboxesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminSandboxesRoute,
} as any)
const AppAdminImplementationsIndexRoute =
  AppAdminImplementationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminImplementationsRoute,
  } as any)
const AppWorkspaceSettingsIndexRoute =
  AppWorkspaceSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceDashboardIndexRoute =
  AppWorkspaceDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppAdminWorkflowsIdRoute = AppAdminWorkflowsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminWorkflowsRoute,
} as any)
const AppAdminSandboxesNameRoute = AppAdminSandboxesNameRouteImport.update({
  id: '/$name',
  path: '/$name',
  getParentRoute: () => AppAdminSandboxesRoute,
} as any)
const AppAdminImplementationsIdRoute =
  AppAdminImplementationsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppAdminImplementationsRoute,
  } as any)
const AppWorkspaceSettingsWorkspaceRoute =
  AppWorkspaceSettingsWorkspaceRouteImport.update({
    id: '/workspace',
    path: '/workspace',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsTagsRoute =
  AppWorkspaceSettingsTagsRouteImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsSecretsRoute =
  AppWorkspaceSettingsSecretsRouteImport.update({
    id: '/secrets',
    path: '/secrets',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsRiskRoute =
  AppWorkspaceSettingsRiskRouteImport.update({
    id: '/risk',
    path: '/risk',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsPlansRoute =
  AppWorkspaceSettingsPlansRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsMembersRoute =
  AppWorkspaceSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsKnowledgeRoute =
  AppWorkspaceSettingsKnowledgeRouteImport.update({
    id: '/knowledge',
    path: '/knowledge',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsFrictionRoute =
  AppWorkspaceSettingsFrictionRouteImport.update({
    id: '/friction',
    path: '/friction',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsBillingRoute =
  AppWorkspaceSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceDashboardSearchRoute =
  AppWorkspaceDashboardSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceSettingsIntegrationsIndexRoute =
  AppWorkspaceSettingsIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsAccountIndexRoute =
  AppWorkspaceSettingsAccountIndexRouteImport.update({
    id: '/account/',
    path: '/account/',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceDashboardTasksIndexRoute =
  AppWorkspaceDashboardTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardSessionsIndexRoute =
  AppWorkspaceDashboardSessionsIndexRouteImport.update({
    id: '/sessions/',
    path: '/sessions/',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardKnowledgeIndexRoute =
  AppWorkspaceDashboardKnowledgeIndexRouteImport.update({
    id: '/knowledge/',
    path: '/knowledge/',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardInsightsIndexRoute =
  AppWorkspaceDashboardInsightsIndexRouteImport.update({
    id: '/insights/',
    path: '/insights/',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardImplementationsIndexRoute =
  AppWorkspaceDashboardImplementationsIndexRouteImport.update({
    id: '/implementations/',
    path: '/implementations/',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardFrictionIndexRoute =
  AppWorkspaceDashboardFrictionIndexRouteImport.update({
    id: '/friction/',
    path: '/friction/',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardBriefsIndexRoute =
  AppWorkspaceDashboardBriefsIndexRouteImport.update({
    id: '/briefs/',
    path: '/briefs/',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardAutomationsIndexRoute =
  AppWorkspaceDashboardAutomationsIndexRouteImport.update({
    id: '/automations/',
    path: '/automations/',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceSettingsIntegrationsSupabaseRoute =
  AppWorkspaceSettingsIntegrationsSupabaseRouteImport.update({
    id: '/integrations/supabase',
    path: '/integrations/supabase',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsIntegrationsSentryRoute =
  AppWorkspaceSettingsIntegrationsSentryRouteImport.update({
    id: '/integrations/sentry',
    path: '/integrations/sentry',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsIntegrationsNeonRoute =
  AppWorkspaceSettingsIntegrationsNeonRouteImport.update({
    id: '/integrations/neon',
    path: '/integrations/neon',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsIntegrationsMcpSetupRoute =
  AppWorkspaceSettingsIntegrationsMcpSetupRouteImport.update({
    id: '/integrations/mcp-setup',
    path: '/integrations/mcp-setup',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsIntegrationsLinearRoute =
  AppWorkspaceSettingsIntegrationsLinearRouteImport.update({
    id: '/integrations/linear',
    path: '/integrations/linear',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsIntegrationsGithubRoute =
  AppWorkspaceSettingsIntegrationsGithubRouteImport.update({
    id: '/integrations/github',
    path: '/integrations/github',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsIntegrationsClaudeCodeRoute =
  AppWorkspaceSettingsIntegrationsClaudeCodeRouteImport.update({
    id: '/integrations/claude-code',
    path: '/integrations/claude-code',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsAccountProfileRoute =
  AppWorkspaceSettingsAccountProfileRouteImport.update({
    id: '/account/profile',
    path: '/account/profile',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsAccountPreferencesRoute =
  AppWorkspaceSettingsAccountPreferencesRouteImport.update({
    id: '/account/preferences',
    path: '/account/preferences',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsAccountConnectionsRoute =
  AppWorkspaceSettingsAccountConnectionsRouteImport.update({
    id: '/account/connections',
    path: '/account/connections',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceSettingsAccountApiRoute =
  AppWorkspaceSettingsAccountApiRouteImport.update({
    id: '/account/api',
    path: '/account/api',
    getParentRoute: () => AppWorkspaceSettingsRoute,
  } as any)
const AppWorkspaceDashboardTasksIdRoute =
  AppWorkspaceDashboardTasksIdRouteImport.update({
    id: '/tasks/$id',
    path: '/tasks/$id',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardSessionsIdRoute =
  AppWorkspaceDashboardSessionsIdRouteImport.update({
    id: '/sessions/$id',
    path: '/sessions/$id',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardKnowledgeIdRoute =
  AppWorkspaceDashboardKnowledgeIdRouteImport.update({
    id: '/knowledge/$id',
    path: '/knowledge/$id',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardImplementationsIdRoute =
  AppWorkspaceDashboardImplementationsIdRouteImport.update({
    id: '/implementations/$id',
    path: '/implementations/$id',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardBriefsIdRoute =
  AppWorkspaceDashboardBriefsIdRouteImport.update({
    id: '/briefs/$id',
    path: '/briefs/$id',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardAutomationsNewRoute =
  AppWorkspaceDashboardAutomationsNewRouteImport.update({
    id: '/automations/new',
    path: '/automations/new',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardAutomationsIdIndexRoute =
  AppWorkspaceDashboardAutomationsIdIndexRouteImport.update({
    id: '/automations/$id/',
    path: '/automations/$id/',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)
const AppWorkspaceDashboardAutomationsIdEditRoute =
  AppWorkspaceDashboardAutomationsIdEditRouteImport.update({
    id: '/automations/$id/edit',
    path: '/automations/$id/edit',
    getParentRoute: () => AppWorkspaceDashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/device': typeof DeviceRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/$workspace': typeof AppWorkspaceDashboardRouteWithChildren
  '/accept-invite': typeof AppAcceptInviteRouteWithChildren
  '/admin': typeof AppAdminRouteWithChildren
  '/getting-started': typeof AppGettingStartedRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/desktop/authorize': typeof DesktopAuthorizeRoute
  '/desktop/reset-password': typeof DesktopResetPasswordRoute
  '/$workspace/settings': typeof AppWorkspaceSettingsRouteWithChildren
  '/accept-invite/$token': typeof AppAcceptInviteTokenRoute
  '/admin/implementations': typeof AppAdminImplementationsRouteWithChildren
  '/admin/sandboxes': typeof AppAdminSandboxesRouteWithChildren
  '/admin/users': typeof AppAdminUsersRoute
  '/admin/waitlist': typeof AppAdminWaitlistRoute
  '/admin/workflows': typeof AppAdminWorkflowsRouteWithChildren
  '/admin/': typeof AppAdminIndexRoute
  '/getting-started/': typeof AppGettingStartedIndexRoute
  '/$workspace/search': typeof AppWorkspaceDashboardSearchRoute
  '/$workspace/settings/billing': typeof AppWorkspaceSettingsBillingRoute
  '/$workspace/settings/friction': typeof AppWorkspaceSettingsFrictionRoute
  '/$workspace/settings/knowledge': typeof AppWorkspaceSettingsKnowledgeRoute
  '/$workspace/settings/members': typeof AppWorkspaceSettingsMembersRoute
  '/$workspace/settings/plans': typeof AppWorkspaceSettingsPlansRoute
  '/$workspace/settings/risk': typeof AppWorkspaceSettingsRiskRoute
  '/$workspace/settings/secrets': typeof AppWorkspaceSettingsSecretsRoute
  '/$workspace/settings/tags': typeof AppWorkspaceSettingsTagsRoute
  '/$workspace/settings/workspace': typeof AppWorkspaceSettingsWorkspaceRoute
  '/admin/implementations/$id': typeof AppAdminImplementationsIdRoute
  '/admin/sandboxes/$name': typeof AppAdminSandboxesNameRoute
  '/admin/workflows/$id': typeof AppAdminWorkflowsIdRoute
  '/$workspace/': typeof AppWorkspaceDashboardIndexRoute
  '/$workspace/settings/': typeof AppWorkspaceSettingsIndexRoute
  '/admin/implementations/': typeof AppAdminImplementationsIndexRoute
  '/admin/sandboxes/': typeof AppAdminSandboxesIndexRoute
  '/admin/workflows/': typeof AppAdminWorkflowsIndexRoute
  '/$workspace/automations/new': typeof AppWorkspaceDashboardAutomationsNewRoute
  '/$workspace/briefs/$id': typeof AppWorkspaceDashboardBriefsIdRoute
  '/$workspace/implementations/$id': typeof AppWorkspaceDashboardImplementationsIdRoute
  '/$workspace/knowledge/$id': typeof AppWorkspaceDashboardKnowledgeIdRoute
  '/$workspace/sessions/$id': typeof AppWorkspaceDashboardSessionsIdRoute
  '/$workspace/tasks/$id': typeof AppWorkspaceDashboardTasksIdRoute
  '/$workspace/settings/account/api': typeof AppWorkspaceSettingsAccountApiRoute
  '/$workspace/settings/account/connections': typeof AppWorkspaceSettingsAccountConnectionsRoute
  '/$workspace/settings/account/preferences': typeof AppWorkspaceSettingsAccountPreferencesRoute
  '/$workspace/settings/account/profile': typeof AppWorkspaceSettingsAccountProfileRoute
  '/$workspace/settings/integrations/claude-code': typeof AppWorkspaceSettingsIntegrationsClaudeCodeRoute
  '/$workspace/settings/integrations/github': typeof AppWorkspaceSettingsIntegrationsGithubRoute
  '/$workspace/settings/integrations/linear': typeof AppWorkspaceSettingsIntegrationsLinearRoute
  '/$workspace/settings/integrations/mcp-setup': typeof AppWorkspaceSettingsIntegrationsMcpSetupRoute
  '/$workspace/settings/integrations/neon': typeof AppWorkspaceSettingsIntegrationsNeonRoute
  '/$workspace/settings/integrations/sentry': typeof AppWorkspaceSettingsIntegrationsSentryRoute
  '/$workspace/settings/integrations/supabase': typeof AppWorkspaceSettingsIntegrationsSupabaseRoute
  '/$workspace/automations/': typeof AppWorkspaceDashboardAutomationsIndexRoute
  '/$workspace/briefs/': typeof AppWorkspaceDashboardBriefsIndexRoute
  '/$workspace/friction/': typeof AppWorkspaceDashboardFrictionIndexRoute
  '/$workspace/implementations/': typeof AppWorkspaceDashboardImplementationsIndexRoute
  '/$workspace/insights/': typeof AppWorkspaceDashboardInsightsIndexRoute
  '/$workspace/knowledge/': typeof AppWorkspaceDashboardKnowledgeIndexRoute
  '/$workspace/sessions/': typeof AppWorkspaceDashboardSessionsIndexRoute
  '/$workspace/tasks/': typeof AppWorkspaceDashboardTasksIndexRoute
  '/$workspace/settings/account/': typeof AppWorkspaceSettingsAccountIndexRoute
  '/$workspace/settings/integrations/': typeof AppWorkspaceSettingsIntegrationsIndexRoute
  '/$workspace/automations/$id/edit': typeof AppWorkspaceDashboardAutomationsIdEditRoute
  '/$workspace/automations/$id/': typeof AppWorkspaceDashboardAutomationsIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/device': typeof DeviceRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/$workspace': typeof AppWorkspaceDashboardIndexRoute
  '/accept-invite': typeof AppAcceptInviteRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/desktop/authorize': typeof DesktopAuthorizeRoute
  '/desktop/reset-password': typeof DesktopResetPasswordRoute
  '/accept-invite/$token': typeof AppAcceptInviteTokenRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/admin/waitlist': typeof AppAdminWaitlistRoute
  '/admin': typeof AppAdminIndexRoute
  '/getting-started': typeof AppGettingStartedIndexRoute
  '/$workspace/search': typeof AppWorkspaceDashboardSearchRoute
  '/$workspace/settings/billing': typeof AppWorkspaceSettingsBillingRoute
  '/$workspace/settings/friction': typeof AppWorkspaceSettingsFrictionRoute
  '/$workspace/settings/knowledge': typeof AppWorkspaceSettingsKnowledgeRoute
  '/$workspace/settings/members': typeof AppWorkspaceSettingsMembersRoute
  '/$workspace/settings/plans': typeof AppWorkspaceSettingsPlansRoute
  '/$workspace/settings/risk': typeof AppWorkspaceSettingsRiskRoute
  '/$workspace/settings/secrets': typeof AppWorkspaceSettingsSecretsRoute
  '/$workspace/settings/tags': typeof AppWorkspaceSettingsTagsRoute
  '/$workspace/settings/workspace': typeof AppWorkspaceSettingsWorkspaceRoute
  '/admin/implementations/$id': typeof AppAdminImplementationsIdRoute
  '/admin/sandboxes/$name': typeof AppAdminSandboxesNameRoute
  '/admin/workflows/$id': typeof AppAdminWorkflowsIdRoute
  '/$workspace/settings': typeof AppWorkspaceSettingsIndexRoute
  '/admin/implementations': typeof AppAdminImplementationsIndexRoute
  '/admin/sandboxes': typeof AppAdminSandboxesIndexRoute
  '/admin/workflows': typeof AppAdminWorkflowsIndexRoute
  '/$workspace/automations/new': typeof AppWorkspaceDashboardAutomationsNewRoute
  '/$workspace/briefs/$id': typeof AppWorkspaceDashboardBriefsIdRoute
  '/$workspace/implementations/$id': typeof AppWorkspaceDashboardImplementationsIdRoute
  '/$workspace/knowledge/$id': typeof AppWorkspaceDashboardKnowledgeIdRoute
  '/$workspace/sessions/$id': typeof AppWorkspaceDashboardSessionsIdRoute
  '/$workspace/tasks/$id': typeof AppWorkspaceDashboardTasksIdRoute
  '/$workspace/settings/account/api': typeof AppWorkspaceSettingsAccountApiRoute
  '/$workspace/settings/account/connections': typeof AppWorkspaceSettingsAccountConnectionsRoute
  '/$workspace/settings/account/preferences': typeof AppWorkspaceSettingsAccountPreferencesRoute
  '/$workspace/settings/account/profile': typeof AppWorkspaceSettingsAccountProfileRoute
  '/$workspace/settings/integrations/claude-code': typeof AppWorkspaceSettingsIntegrationsClaudeCodeRoute
  '/$workspace/settings/integrations/github': typeof AppWorkspaceSettingsIntegrationsGithubRoute
  '/$workspace/settings/integrations/linear': typeof AppWorkspaceSettingsIntegrationsLinearRoute
  '/$workspace/settings/integrations/mcp-setup': typeof AppWorkspaceSettingsIntegrationsMcpSetupRoute
  '/$workspace/settings/integrations/neon': typeof AppWorkspaceSettingsIntegrationsNeonRoute
  '/$workspace/settings/integrations/sentry': typeof AppWorkspaceSettingsIntegrationsSentryRoute
  '/$workspace/settings/integrations/supabase': typeof AppWorkspaceSettingsIntegrationsSupabaseRoute
  '/$workspace/automations': typeof AppWorkspaceDashboardAutomationsIndexRoute
  '/$workspace/briefs': typeof AppWorkspaceDashboardBriefsIndexRoute
  '/$workspace/friction': typeof AppWorkspaceDashboardFrictionIndexRoute
  '/$workspace/implementations': typeof AppWorkspaceDashboardImplementationsIndexRoute
  '/$workspace/insights': typeof AppWorkspaceDashboardInsightsIndexRoute
  '/$workspace/knowledge': typeof AppWorkspaceDashboardKnowledgeIndexRoute
  '/$workspace/sessions': typeof AppWorkspaceDashboardSessionsIndexRoute
  '/$workspace/tasks': typeof AppWorkspaceDashboardTasksIndexRoute
  '/$workspace/settings/account': typeof AppWorkspaceSettingsAccountIndexRoute
  '/$workspace/settings/integrations': typeof AppWorkspaceSettingsIntegrationsIndexRoute
  '/$workspace/automations/$id/edit': typeof AppWorkspaceDashboardAutomationsIdEditRoute
  '/$workspace/automations/$id': typeof AppWorkspaceDashboardAutomationsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/device': typeof DeviceRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_app/$workspace': typeof AppWorkspaceRouteWithChildren
  '/_app/accept-invite': typeof AppAcceptInviteRouteWithChildren
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/getting-started': typeof AppGettingStartedRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/desktop/authorize': typeof DesktopAuthorizeRoute
  '/desktop/reset-password': typeof DesktopResetPasswordRoute
  '/_app/': typeof AppIndexRoute
  '/_app/$workspace/_dashboard': typeof AppWorkspaceDashboardRouteWithChildren
  '/_app/$workspace/settings': typeof AppWorkspaceSettingsRouteWithChildren
  '/_app/accept-invite/$token': typeof AppAcceptInviteTokenRoute
  '/_app/admin/implementations': typeof AppAdminImplementationsRouteWithChildren
  '/_app/admin/sandboxes': typeof AppAdminSandboxesRouteWithChildren
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/admin/waitlist': typeof AppAdminWaitlistRoute
  '/_app/admin/workflows': typeof AppAdminWorkflowsRouteWithChildren
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/getting-started/': typeof AppGettingStartedIndexRoute
  '/_app/$workspace/_dashboard/search': typeof AppWorkspaceDashboardSearchRoute
  '/_app/$workspace/settings/billing': typeof AppWorkspaceSettingsBillingRoute
  '/_app/$workspace/settings/friction': typeof AppWorkspaceSettingsFrictionRoute
  '/_app/$workspace/settings/knowledge': typeof AppWorkspaceSettingsKnowledgeRoute
  '/_app/$workspace/settings/members': typeof AppWorkspaceSettingsMembersRoute
  '/_app/$workspace/settings/plans': typeof AppWorkspaceSettingsPlansRoute
  '/_app/$workspace/settings/risk': typeof AppWorkspaceSettingsRiskRoute
  '/_app/$workspace/settings/secrets': typeof AppWorkspaceSettingsSecretsRoute
  '/_app/$workspace/settings/tags': typeof AppWorkspaceSettingsTagsRoute
  '/_app/$workspace/settings/workspace': typeof AppWorkspaceSettingsWorkspaceRoute
  '/_app/admin/implementations/$id': typeof AppAdminImplementationsIdRoute
  '/_app/admin/sandboxes/$name': typeof AppAdminSandboxesNameRoute
  '/_app/admin/workflows/$id': typeof AppAdminWorkflowsIdRoute
  '/_app/$workspace/_dashboard/': typeof AppWorkspaceDashboardIndexRoute
  '/_app/$workspace/settings/': typeof AppWorkspaceSettingsIndexRoute
  '/_app/admin/implementations/': typeof AppAdminImplementationsIndexRoute
  '/_app/admin/sandboxes/': typeof AppAdminSandboxesIndexRoute
  '/_app/admin/workflows/': typeof AppAdminWorkflowsIndexRoute
  '/_app/$workspace/_dashboard/automations/new': typeof AppWorkspaceDashboardAutomationsNewRoute
  '/_app/$workspace/_dashboard/briefs/$id': typeof AppWorkspaceDashboardBriefsIdRoute
  '/_app/$workspace/_dashboard/implementations/$id': typeof AppWorkspaceDashboardImplementationsIdRoute
  '/_app/$workspace/_dashboard/knowledge/$id': typeof AppWorkspaceDashboardKnowledgeIdRoute
  '/_app/$workspace/_dashboard/sessions/$id': typeof AppWorkspaceDashboardSessionsIdRoute
  '/_app/$workspace/_dashboard/tasks/$id': typeof AppWorkspaceDashboardTasksIdRoute
  '/_app/$workspace/settings/account/api': typeof AppWorkspaceSettingsAccountApiRoute
  '/_app/$workspace/settings/account/connections': typeof AppWorkspaceSettingsAccountConnectionsRoute
  '/_app/$workspace/settings/account/preferences': typeof AppWorkspaceSettingsAccountPreferencesRoute
  '/_app/$workspace/settings/account/profile': typeof AppWorkspaceSettingsAccountProfileRoute
  '/_app/$workspace/settings/integrations/claude-code': typeof AppWorkspaceSettingsIntegrationsClaudeCodeRoute
  '/_app/$workspace/settings/integrations/github': typeof AppWorkspaceSettingsIntegrationsGithubRoute
  '/_app/$workspace/settings/integrations/linear': typeof AppWorkspaceSettingsIntegrationsLinearRoute
  '/_app/$workspace/settings/integrations/mcp-setup': typeof AppWorkspaceSettingsIntegrationsMcpSetupRoute
  '/_app/$workspace/settings/integrations/neon': typeof AppWorkspaceSettingsIntegrationsNeonRoute
  '/_app/$workspace/settings/integrations/sentry': typeof AppWorkspaceSettingsIntegrationsSentryRoute
  '/_app/$workspace/settings/integrations/supabase': typeof AppWorkspaceSettingsIntegrationsSupabaseRoute
  '/_app/$workspace/_dashboard/automations/': typeof AppWorkspaceDashboardAutomationsIndexRoute
  '/_app/$workspace/_dashboard/briefs/': typeof AppWorkspaceDashboardBriefsIndexRoute
  '/_app/$workspace/_dashboard/friction/': typeof AppWorkspaceDashboardFrictionIndexRoute
  '/_app/$workspace/_dashboard/implementations/': typeof AppWorkspaceDashboardImplementationsIndexRoute
  '/_app/$workspace/_dashboard/insights/': typeof AppWorkspaceDashboardInsightsIndexRoute
  '/_app/$workspace/_dashboard/knowledge/': typeof AppWorkspaceDashboardKnowledgeIndexRoute
  '/_app/$workspace/_dashboard/sessions/': typeof AppWorkspaceDashboardSessionsIndexRoute
  '/_app/$workspace/_dashboard/tasks/': typeof AppWorkspaceDashboardTasksIndexRoute
  '/_app/$workspace/settings/account/': typeof AppWorkspaceSettingsAccountIndexRoute
  '/_app/$workspace/settings/integrations/': typeof AppWorkspaceSettingsIntegrationsIndexRoute
  '/_app/$workspace/_dashboard/automations/$id/edit': typeof AppWorkspaceDashboardAutomationsIdEditRoute
  '/_app/$workspace/_dashboard/automations/$id/': typeof AppWorkspaceDashboardAutomationsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/device'
    | '/privacy'
    | '/terms'
    | '/$workspace'
    | '/accept-invite'
    | '/admin'
    | '/getting-started'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/desktop/authorize'
    | '/desktop/reset-password'
    | '/$workspace/settings'
    | '/accept-invite/$token'
    | '/admin/implementations'
    | '/admin/sandboxes'
    | '/admin/users'
    | '/admin/waitlist'
    | '/admin/workflows'
    | '/admin/'
    | '/getting-started/'
    | '/$workspace/search'
    | '/$workspace/settings/billing'
    | '/$workspace/settings/friction'
    | '/$workspace/settings/knowledge'
    | '/$workspace/settings/members'
    | '/$workspace/settings/plans'
    | '/$workspace/settings/risk'
    | '/$workspace/settings/secrets'
    | '/$workspace/settings/tags'
    | '/$workspace/settings/workspace'
    | '/admin/implementations/$id'
    | '/admin/sandboxes/$name'
    | '/admin/workflows/$id'
    | '/$workspace/'
    | '/$workspace/settings/'
    | '/admin/implementations/'
    | '/admin/sandboxes/'
    | '/admin/workflows/'
    | '/$workspace/automations/new'
    | '/$workspace/briefs/$id'
    | '/$workspace/implementations/$id'
    | '/$workspace/knowledge/$id'
    | '/$workspace/sessions/$id'
    | '/$workspace/tasks/$id'
    | '/$workspace/settings/account/api'
    | '/$workspace/settings/account/connections'
    | '/$workspace/settings/account/preferences'
    | '/$workspace/settings/account/profile'
    | '/$workspace/settings/integrations/claude-code'
    | '/$workspace/settings/integrations/github'
    | '/$workspace/settings/integrations/linear'
    | '/$workspace/settings/integrations/mcp-setup'
    | '/$workspace/settings/integrations/neon'
    | '/$workspace/settings/integrations/sentry'
    | '/$workspace/settings/integrations/supabase'
    | '/$workspace/automations/'
    | '/$workspace/briefs/'
    | '/$workspace/friction/'
    | '/$workspace/implementations/'
    | '/$workspace/insights/'
    | '/$workspace/knowledge/'
    | '/$workspace/sessions/'
    | '/$workspace/tasks/'
    | '/$workspace/settings/account/'
    | '/$workspace/settings/integrations/'
    | '/$workspace/automations/$id/edit'
    | '/$workspace/automations/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/device'
    | '/privacy'
    | '/terms'
    | '/$workspace'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/desktop/authorize'
    | '/desktop/reset-password'
    | '/accept-invite/$token'
    | '/admin/users'
    | '/admin/waitlist'
    | '/admin'
    | '/getting-started'
    | '/$workspace/search'
    | '/$workspace/settings/billing'
    | '/$workspace/settings/friction'
    | '/$workspace/settings/knowledge'
    | '/$workspace/settings/members'
    | '/$workspace/settings/plans'
    | '/$workspace/settings/risk'
    | '/$workspace/settings/secrets'
    | '/$workspace/settings/tags'
    | '/$workspace/settings/workspace'
    | '/admin/implementations/$id'
    | '/admin/sandboxes/$name'
    | '/admin/workflows/$id'
    | '/$workspace/settings'
    | '/admin/implementations'
    | '/admin/sandboxes'
    | '/admin/workflows'
    | '/$workspace/automations/new'
    | '/$workspace/briefs/$id'
    | '/$workspace/implementations/$id'
    | '/$workspace/knowledge/$id'
    | '/$workspace/sessions/$id'
    | '/$workspace/tasks/$id'
    | '/$workspace/settings/account/api'
    | '/$workspace/settings/account/connections'
    | '/$workspace/settings/account/preferences'
    | '/$workspace/settings/account/profile'
    | '/$workspace/settings/integrations/claude-code'
    | '/$workspace/settings/integrations/github'
    | '/$workspace/settings/integrations/linear'
    | '/$workspace/settings/integrations/mcp-setup'
    | '/$workspace/settings/integrations/neon'
    | '/$workspace/settings/integrations/sentry'
    | '/$workspace/settings/integrations/supabase'
    | '/$workspace/automations'
    | '/$workspace/briefs'
    | '/$workspace/friction'
    | '/$workspace/implementations'
    | '/$workspace/insights'
    | '/$workspace/knowledge'
    | '/$workspace/sessions'
    | '/$workspace/tasks'
    | '/$workspace/settings/account'
    | '/$workspace/settings/integrations'
    | '/$workspace/automations/$id/edit'
    | '/$workspace/automations/$id'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/device'
    | '/privacy'
    | '/terms'
    | '/_app/$workspace'
    | '/_app/accept-invite'
    | '/_app/admin'
    | '/_app/getting-started'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/signup'
    | '/desktop/authorize'
    | '/desktop/reset-password'
    | '/_app/'
    | '/_app/$workspace/_dashboard'
    | '/_app/$workspace/settings'
    | '/_app/accept-invite/$token'
    | '/_app/admin/implementations'
    | '/_app/admin/sandboxes'
    | '/_app/admin/users'
    | '/_app/admin/waitlist'
    | '/_app/admin/workflows'
    | '/_app/admin/'
    | '/_app/getting-started/'
    | '/_app/$workspace/_dashboard/search'
    | '/_app/$workspace/settings/billing'
    | '/_app/$workspace/settings/friction'
    | '/_app/$workspace/settings/knowledge'
    | '/_app/$workspace/settings/members'
    | '/_app/$workspace/settings/plans'
    | '/_app/$workspace/settings/risk'
    | '/_app/$workspace/settings/secrets'
    | '/_app/$workspace/settings/tags'
    | '/_app/$workspace/settings/workspace'
    | '/_app/admin/implementations/$id'
    | '/_app/admin/sandboxes/$name'
    | '/_app/admin/workflows/$id'
    | '/_app/$workspace/_dashboard/'
    | '/_app/$workspace/settings/'
    | '/_app/admin/implementations/'
    | '/_app/admin/sandboxes/'
    | '/_app/admin/workflows/'
    | '/_app/$workspace/_dashboard/automations/new'
    | '/_app/$workspace/_dashboard/briefs/$id'
    | '/_app/$workspace/_dashboard/implementations/$id'
    | '/_app/$workspace/_dashboard/knowledge/$id'
    | '/_app/$workspace/_dashboard/sessions/$id'
    | '/_app/$workspace/_dashboard/tasks/$id'
    | '/_app/$workspace/settings/account/api'
    | '/_app/$workspace/settings/account/connections'
    | '/_app/$workspace/settings/account/preferences'
    | '/_app/$workspace/settings/account/profile'
    | '/_app/$workspace/settings/integrations/claude-code'
    | '/_app/$workspace/settings/integrations/github'
    | '/_app/$workspace/settings/integrations/linear'
    | '/_app/$workspace/settings/integrations/mcp-setup'
    | '/_app/$workspace/settings/integrations/neon'
    | '/_app/$workspace/settings/integrations/sentry'
    | '/_app/$workspace/settings/integrations/supabase'
    | '/_app/$workspace/_dashboard/automations/'
    | '/_app/$workspace/_dashboard/briefs/'
    | '/_app/$workspace/_dashboard/friction/'
    | '/_app/$workspace/_dashboard/implementations/'
    | '/_app/$workspace/_dashboard/insights/'
    | '/_app/$workspace/_dashboard/knowledge/'
    | '/_app/$workspace/_dashboard/sessions/'
    | '/_app/$workspace/_dashboard/tasks/'
    | '/_app/$workspace/settings/account/'
    | '/_app/$workspace/settings/integrations/'
    | '/_app/$workspace/_dashboard/automations/$id/edit'
    | '/_app/$workspace/_dashboard/automations/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  DeviceRoute: typeof DeviceRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  DesktopAuthorizeRoute: typeof DesktopAuthorizeRoute
  DesktopResetPasswordRoute: typeof DesktopResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/desktop/reset-password': {
      id: '/desktop/reset-password'
      path: '/desktop/reset-password'
      fullPath: '/desktop/reset-password'
      preLoaderRoute: typeof DesktopResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desktop/authorize': {
      id: '/desktop/authorize'
      path: '/desktop/authorize'
      fullPath: '/desktop/authorize'
      preLoaderRoute: typeof DesktopAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/getting-started': {
      id: '/_app/getting-started'
      path: '/getting-started'
      fullPath: '/getting-started'
      preLoaderRoute: typeof AppGettingStartedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accept-invite': {
      id: '/_app/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AppAcceptInviteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$workspace': {
      id: '/_app/$workspace'
      path: '/$workspace'
      fullPath: '/$workspace'
      preLoaderRoute: typeof AppWorkspaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/getting-started/': {
      id: '/_app/getting-started/'
      path: '/'
      fullPath: '/getting-started/'
      preLoaderRoute: typeof AppGettingStartedIndexRouteImport
      parentRoute: typeof AppGettingStartedRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/workflows': {
      id: '/_app/admin/workflows'
      path: '/workflows'
      fullPath: '/admin/workflows'
      preLoaderRoute: typeof AppAdminWorkflowsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/waitlist': {
      id: '/_app/admin/waitlist'
      path: '/waitlist'
      fullPath: '/admin/waitlist'
      preLoaderRoute: typeof AppAdminWaitlistRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/sandboxes': {
      id: '/_app/admin/sandboxes'
      path: '/sandboxes'
      fullPath: '/admin/sandboxes'
      preLoaderRoute: typeof AppAdminSandboxesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/implementations': {
      id: '/_app/admin/implementations'
      path: '/implementations'
      fullPath: '/admin/implementations'
      preLoaderRoute: typeof AppAdminImplementationsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/accept-invite/$token': {
      id: '/_app/accept-invite/$token'
      path: '/$token'
      fullPath: '/accept-invite/$token'
      preLoaderRoute: typeof AppAcceptInviteTokenRouteImport
      parentRoute: typeof AppAcceptInviteRoute
    }
    '/_app/$workspace/settings': {
      id: '/_app/$workspace/settings'
      path: '/settings'
      fullPath: '/$workspace/settings'
      preLoaderRoute: typeof AppWorkspaceSettingsRouteImport
      parentRoute: typeof AppWorkspaceRoute
    }
    '/_app/$workspace/_dashboard': {
      id: '/_app/$workspace/_dashboard'
      path: ''
      fullPath: '/$workspace'
      preLoaderRoute: typeof AppWorkspaceDashboardRouteImport
      parentRoute: typeof AppWorkspaceRoute
    }
    '/_app/admin/workflows/': {
      id: '/_app/admin/workflows/'
      path: '/'
      fullPath: '/admin/workflows/'
      preLoaderRoute: typeof AppAdminWorkflowsIndexRouteImport
      parentRoute: typeof AppAdminWorkflowsRoute
    }
    '/_app/admin/sandboxes/': {
      id: '/_app/admin/sandboxes/'
      path: '/'
      fullPath: '/admin/sandboxes/'
      preLoaderRoute: typeof AppAdminSandboxesIndexRouteImport
      parentRoute: typeof AppAdminSandboxesRoute
    }
    '/_app/admin/implementations/': {
      id: '/_app/admin/implementations/'
      path: '/'
      fullPath: '/admin/implementations/'
      preLoaderRoute: typeof AppAdminImplementationsIndexRouteImport
      parentRoute: typeof AppAdminImplementationsRoute
    }
    '/_app/$workspace/settings/': {
      id: '/_app/$workspace/settings/'
      path: '/'
      fullPath: '/$workspace/settings/'
      preLoaderRoute: typeof AppWorkspaceSettingsIndexRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/_dashboard/': {
      id: '/_app/$workspace/_dashboard/'
      path: '/'
      fullPath: '/$workspace/'
      preLoaderRoute: typeof AppWorkspaceDashboardIndexRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/admin/workflows/$id': {
      id: '/_app/admin/workflows/$id'
      path: '/$id'
      fullPath: '/admin/workflows/$id'
      preLoaderRoute: typeof AppAdminWorkflowsIdRouteImport
      parentRoute: typeof AppAdminWorkflowsRoute
    }
    '/_app/admin/sandboxes/$name': {
      id: '/_app/admin/sandboxes/$name'
      path: '/$name'
      fullPath: '/admin/sandboxes/$name'
      preLoaderRoute: typeof AppAdminSandboxesNameRouteImport
      parentRoute: typeof AppAdminSandboxesRoute
    }
    '/_app/admin/implementations/$id': {
      id: '/_app/admin/implementations/$id'
      path: '/$id'
      fullPath: '/admin/implementations/$id'
      preLoaderRoute: typeof AppAdminImplementationsIdRouteImport
      parentRoute: typeof AppAdminImplementationsRoute
    }
    '/_app/$workspace/settings/workspace': {
      id: '/_app/$workspace/settings/workspace'
      path: '/workspace'
      fullPath: '/$workspace/settings/workspace'
      preLoaderRoute: typeof AppWorkspaceSettingsWorkspaceRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/tags': {
      id: '/_app/$workspace/settings/tags'
      path: '/tags'
      fullPath: '/$workspace/settings/tags'
      preLoaderRoute: typeof AppWorkspaceSettingsTagsRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/secrets': {
      id: '/_app/$workspace/settings/secrets'
      path: '/secrets'
      fullPath: '/$workspace/settings/secrets'
      preLoaderRoute: typeof AppWorkspaceSettingsSecretsRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/risk': {
      id: '/_app/$workspace/settings/risk'
      path: '/risk'
      fullPath: '/$workspace/settings/risk'
      preLoaderRoute: typeof AppWorkspaceSettingsRiskRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/plans': {
      id: '/_app/$workspace/settings/plans'
      path: '/plans'
      fullPath: '/$workspace/settings/plans'
      preLoaderRoute: typeof AppWorkspaceSettingsPlansRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/members': {
      id: '/_app/$workspace/settings/members'
      path: '/members'
      fullPath: '/$workspace/settings/members'
      preLoaderRoute: typeof AppWorkspaceSettingsMembersRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/knowledge': {
      id: '/_app/$workspace/settings/knowledge'
      path: '/knowledge'
      fullPath: '/$workspace/settings/knowledge'
      preLoaderRoute: typeof AppWorkspaceSettingsKnowledgeRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/friction': {
      id: '/_app/$workspace/settings/friction'
      path: '/friction'
      fullPath: '/$workspace/settings/friction'
      preLoaderRoute: typeof AppWorkspaceSettingsFrictionRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/billing': {
      id: '/_app/$workspace/settings/billing'
      path: '/billing'
      fullPath: '/$workspace/settings/billing'
      preLoaderRoute: typeof AppWorkspaceSettingsBillingRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/_dashboard/search': {
      id: '/_app/$workspace/_dashboard/search'
      path: '/search'
      fullPath: '/$workspace/search'
      preLoaderRoute: typeof AppWorkspaceDashboardSearchRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/settings/integrations/': {
      id: '/_app/$workspace/settings/integrations/'
      path: '/integrations'
      fullPath: '/$workspace/settings/integrations/'
      preLoaderRoute: typeof AppWorkspaceSettingsIntegrationsIndexRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/account/': {
      id: '/_app/$workspace/settings/account/'
      path: '/account'
      fullPath: '/$workspace/settings/account/'
      preLoaderRoute: typeof AppWorkspaceSettingsAccountIndexRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/_dashboard/tasks/': {
      id: '/_app/$workspace/_dashboard/tasks/'
      path: '/tasks'
      fullPath: '/$workspace/tasks/'
      preLoaderRoute: typeof AppWorkspaceDashboardTasksIndexRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/sessions/': {
      id: '/_app/$workspace/_dashboard/sessions/'
      path: '/sessions'
      fullPath: '/$workspace/sessions/'
      preLoaderRoute: typeof AppWorkspaceDashboardSessionsIndexRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/knowledge/': {
      id: '/_app/$workspace/_dashboard/knowledge/'
      path: '/knowledge'
      fullPath: '/$workspace/knowledge/'
      preLoaderRoute: typeof AppWorkspaceDashboardKnowledgeIndexRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/insights/': {
      id: '/_app/$workspace/_dashboard/insights/'
      path: '/insights'
      fullPath: '/$workspace/insights/'
      preLoaderRoute: typeof AppWorkspaceDashboardInsightsIndexRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/implementations/': {
      id: '/_app/$workspace/_dashboard/implementations/'
      path: '/implementations'
      fullPath: '/$workspace/implementations/'
      preLoaderRoute: typeof AppWorkspaceDashboardImplementationsIndexRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/friction/': {
      id: '/_app/$workspace/_dashboard/friction/'
      path: '/friction'
      fullPath: '/$workspace/friction/'
      preLoaderRoute: typeof AppWorkspaceDashboardFrictionIndexRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/briefs/': {
      id: '/_app/$workspace/_dashboard/briefs/'
      path: '/briefs'
      fullPath: '/$workspace/briefs/'
      preLoaderRoute: typeof AppWorkspaceDashboardBriefsIndexRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/automations/': {
      id: '/_app/$workspace/_dashboard/automations/'
      path: '/automations'
      fullPath: '/$workspace/automations/'
      preLoaderRoute: typeof AppWorkspaceDashboardAutomationsIndexRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/settings/integrations/supabase': {
      id: '/_app/$workspace/settings/integrations/supabase'
      path: '/integrations/supabase'
      fullPath: '/$workspace/settings/integrations/supabase'
      preLoaderRoute: typeof AppWorkspaceSettingsIntegrationsSupabaseRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/integrations/sentry': {
      id: '/_app/$workspace/settings/integrations/sentry'
      path: '/integrations/sentry'
      fullPath: '/$workspace/settings/integrations/sentry'
      preLoaderRoute: typeof AppWorkspaceSettingsIntegrationsSentryRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/integrations/neon': {
      id: '/_app/$workspace/settings/integrations/neon'
      path: '/integrations/neon'
      fullPath: '/$workspace/settings/integrations/neon'
      preLoaderRoute: typeof AppWorkspaceSettingsIntegrationsNeonRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/integrations/mcp-setup': {
      id: '/_app/$workspace/settings/integrations/mcp-setup'
      path: '/integrations/mcp-setup'
      fullPath: '/$workspace/settings/integrations/mcp-setup'
      preLoaderRoute: typeof AppWorkspaceSettingsIntegrationsMcpSetupRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/integrations/linear': {
      id: '/_app/$workspace/settings/integrations/linear'
      path: '/integrations/linear'
      fullPath: '/$workspace/settings/integrations/linear'
      preLoaderRoute: typeof AppWorkspaceSettingsIntegrationsLinearRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/integrations/github': {
      id: '/_app/$workspace/settings/integrations/github'
      path: '/integrations/github'
      fullPath: '/$workspace/settings/integrations/github'
      preLoaderRoute: typeof AppWorkspaceSettingsIntegrationsGithubRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/integrations/claude-code': {
      id: '/_app/$workspace/settings/integrations/claude-code'
      path: '/integrations/claude-code'
      fullPath: '/$workspace/settings/integrations/claude-code'
      preLoaderRoute: typeof AppWorkspaceSettingsIntegrationsClaudeCodeRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/account/profile': {
      id: '/_app/$workspace/settings/account/profile'
      path: '/account/profile'
      fullPath: '/$workspace/settings/account/profile'
      preLoaderRoute: typeof AppWorkspaceSettingsAccountProfileRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/account/preferences': {
      id: '/_app/$workspace/settings/account/preferences'
      path: '/account/preferences'
      fullPath: '/$workspace/settings/account/preferences'
      preLoaderRoute: typeof AppWorkspaceSettingsAccountPreferencesRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/account/connections': {
      id: '/_app/$workspace/settings/account/connections'
      path: '/account/connections'
      fullPath: '/$workspace/settings/account/connections'
      preLoaderRoute: typeof AppWorkspaceSettingsAccountConnectionsRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/settings/account/api': {
      id: '/_app/$workspace/settings/account/api'
      path: '/account/api'
      fullPath: '/$workspace/settings/account/api'
      preLoaderRoute: typeof AppWorkspaceSettingsAccountApiRouteImport
      parentRoute: typeof AppWorkspaceSettingsRoute
    }
    '/_app/$workspace/_dashboard/tasks/$id': {
      id: '/_app/$workspace/_dashboard/tasks/$id'
      path: '/tasks/$id'
      fullPath: '/$workspace/tasks/$id'
      preLoaderRoute: typeof AppWorkspaceDashboardTasksIdRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/sessions/$id': {
      id: '/_app/$workspace/_dashboard/sessions/$id'
      path: '/sessions/$id'
      fullPath: '/$workspace/sessions/$id'
      preLoaderRoute: typeof AppWorkspaceDashboardSessionsIdRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/knowledge/$id': {
      id: '/_app/$workspace/_dashboard/knowledge/$id'
      path: '/knowledge/$id'
      fullPath: '/$workspace/knowledge/$id'
      preLoaderRoute: typeof AppWorkspaceDashboardKnowledgeIdRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/implementations/$id': {
      id: '/_app/$workspace/_dashboard/implementations/$id'
      path: '/implementations/$id'
      fullPath: '/$workspace/implementations/$id'
      preLoaderRoute: typeof AppWorkspaceDashboardImplementationsIdRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/briefs/$id': {
      id: '/_app/$workspace/_dashboard/briefs/$id'
      path: '/briefs/$id'
      fullPath: '/$workspace/briefs/$id'
      preLoaderRoute: typeof AppWorkspaceDashboardBriefsIdRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/automations/new': {
      id: '/_app/$workspace/_dashboard/automations/new'
      path: '/automations/new'
      fullPath: '/$workspace/automations/new'
      preLoaderRoute: typeof AppWorkspaceDashboardAutomationsNewRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/automations/$id/': {
      id: '/_app/$workspace/_dashboard/automations/$id/'
      path: '/automations/$id'
      fullPath: '/$workspace/automations/$id/'
      preLoaderRoute: typeof AppWorkspaceDashboardAutomationsIdIndexRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
    '/_app/$workspace/_dashboard/automations/$id/edit': {
      id: '/_app/$workspace/_dashboard/automations/$id/edit'
      path: '/automations/$id/edit'
      fullPath: '/$workspace/automations/$id/edit'
      preLoaderRoute: typeof AppWorkspaceDashboardAutomationsIdEditRouteImport
      parentRoute: typeof AppWorkspaceDashboardRoute
    }
  }
}

interface AppWorkspaceDashboardRouteChildren {
  AppWorkspaceDashboardSearchRoute: typeof AppWorkspaceDashboardSearchRoute
  AppWorkspaceDashboardIndexRoute: typeof AppWorkspaceDashboardIndexRoute
  AppWorkspaceDashboardAutomationsNewRoute: typeof AppWorkspaceDashboardAutomationsNewRoute
  AppWorkspaceDashboardBriefsIdRoute: typeof AppWorkspaceDashboardBriefsIdRoute
  AppWorkspaceDashboardImplementationsIdRoute: typeof AppWorkspaceDashboardImplementationsIdRoute
  AppWorkspaceDashboardKnowledgeIdRoute: typeof AppWorkspaceDashboardKnowledgeIdRoute
  AppWorkspaceDashboardSessionsIdRoute: typeof AppWorkspaceDashboardSessionsIdRoute
  AppWorkspaceDashboardTasksIdRoute: typeof AppWorkspaceDashboardTasksIdRoute
  AppWorkspaceDashboardAutomationsIndexRoute: typeof AppWorkspaceDashboardAutomationsIndexRoute
  AppWorkspaceDashboardBriefsIndexRoute: typeof AppWorkspaceDashboardBriefsIndexRoute
  AppWorkspaceDashboardFrictionIndexRoute: typeof AppWorkspaceDashboardFrictionIndexRoute
  AppWorkspaceDashboardImplementationsIndexRoute: typeof AppWorkspaceDashboardImplementationsIndexRoute
  AppWorkspaceDashboardInsightsIndexRoute: typeof AppWorkspaceDashboardInsightsIndexRoute
  AppWorkspaceDashboardKnowledgeIndexRoute: typeof AppWorkspaceDashboardKnowledgeIndexRoute
  AppWorkspaceDashboardSessionsIndexRoute: typeof AppWorkspaceDashboardSessionsIndexRoute
  AppWorkspaceDashboardTasksIndexRoute: typeof AppWorkspaceDashboardTasksIndexRoute
  AppWorkspaceDashboardAutomationsIdEditRoute: typeof AppWorkspaceDashboardAutomationsIdEditRoute
  AppWorkspaceDashboardAutomationsIdIndexRoute: typeof AppWorkspaceDashboardAutomationsIdIndexRoute
}

const AppWorkspaceDashboardRouteChildren: AppWorkspaceDashboardRouteChildren = {
  AppWorkspaceDashboardSearchRoute: AppWorkspaceDashboardSearchRoute,
  AppWorkspaceDashboardIndexRoute: AppWorkspaceDashboardIndexRoute,
  AppWorkspaceDashboardAutomationsNewRoute:
    AppWorkspaceDashboardAutomationsNewRoute,
  AppWorkspaceDashboardBriefsIdRoute: AppWorkspaceDashboardBriefsIdRoute,
  AppWorkspaceDashboardImplementationsIdRoute:
    AppWorkspaceDashboardImplementationsIdRoute,
  AppWorkspaceDashboardKnowledgeIdRoute: AppWorkspaceDashboardKnowledgeIdRoute,
  AppWorkspaceDashboardSessionsIdRoute: AppWorkspaceDashboardSessionsIdRoute,
  AppWorkspaceDashboardTasksIdRoute: AppWorkspaceDashboardTasksIdRoute,
  AppWorkspaceDashboardAutomationsIndexRoute:
    AppWorkspaceDashboardAutomationsIndexRoute,
  AppWorkspaceDashboardBriefsIndexRoute: AppWorkspaceDashboardBriefsIndexRoute,
  AppWorkspaceDashboardFrictionIndexRoute:
    AppWorkspaceDashboardFrictionIndexRoute,
  AppWorkspaceDashboardImplementationsIndexRoute:
    AppWorkspaceDashboardImplementationsIndexRoute,
  AppWorkspaceDashboardInsightsIndexRoute:
    AppWorkspaceDashboardInsightsIndexRoute,
  AppWorkspaceDashboardKnowledgeIndexRoute:
    AppWorkspaceDashboardKnowledgeIndexRoute,
  AppWorkspaceDashboardSessionsIndexRoute:
    AppWorkspaceDashboardSessionsIndexRoute,
  AppWorkspaceDashboardTasksIndexRoute: AppWorkspaceDashboardTasksIndexRoute,
  AppWorkspaceDashboardAutomationsIdEditRoute:
    AppWorkspaceDashboardAutomationsIdEditRoute,
  AppWorkspaceDashboardAutomationsIdIndexRoute:
    AppWorkspaceDashboardAutomationsIdIndexRoute,
}

const AppWorkspaceDashboardRouteWithChildren =
  AppWorkspaceDashboardRoute._addFileChildren(
    AppWorkspaceDashboardRouteChildren,
  )

interface AppWorkspaceSettingsRouteChildren {
  AppWorkspaceSettingsBillingRoute: typeof AppWorkspaceSettingsBillingRoute
  AppWorkspaceSettingsFrictionRoute: typeof AppWorkspaceSettingsFrictionRoute
  AppWorkspaceSettingsKnowledgeRoute: typeof AppWorkspaceSettingsKnowledgeRoute
  AppWorkspaceSettingsMembersRoute: typeof AppWorkspaceSettingsMembersRoute
  AppWorkspaceSettingsPlansRoute: typeof AppWorkspaceSettingsPlansRoute
  AppWorkspaceSettingsRiskRoute: typeof AppWorkspaceSettingsRiskRoute
  AppWorkspaceSettingsSecretsRoute: typeof AppWorkspaceSettingsSecretsRoute
  AppWorkspaceSettingsTagsRoute: typeof AppWorkspaceSettingsTagsRoute
  AppWorkspaceSettingsWorkspaceRoute: typeof AppWorkspaceSettingsWorkspaceRoute
  AppWorkspaceSettingsIndexRoute: typeof AppWorkspaceSettingsIndexRoute
  AppWorkspaceSettingsAccountApiRoute: typeof AppWorkspaceSettingsAccountApiRoute
  AppWorkspaceSettingsAccountConnectionsRoute: typeof AppWorkspaceSettingsAccountConnectionsRoute
  AppWorkspaceSettingsAccountPreferencesRoute: typeof AppWorkspaceSettingsAccountPreferencesRoute
  AppWorkspaceSettingsAccountProfileRoute: typeof AppWorkspaceSettingsAccountProfileRoute
  AppWorkspaceSettingsIntegrationsClaudeCodeRoute: typeof AppWorkspaceSettingsIntegrationsClaudeCodeRoute
  AppWorkspaceSettingsIntegrationsGithubRoute: typeof AppWorkspaceSettingsIntegrationsGithubRoute
  AppWorkspaceSettingsIntegrationsLinearRoute: typeof AppWorkspaceSettingsIntegrationsLinearRoute
  AppWorkspaceSettingsIntegrationsMcpSetupRoute: typeof AppWorkspaceSettingsIntegrationsMcpSetupRoute
  AppWorkspaceSettingsIntegrationsNeonRoute: typeof AppWorkspaceSettingsIntegrationsNeonRoute
  AppWorkspaceSettingsIntegrationsSentryRoute: typeof AppWorkspaceSettingsIntegrationsSentryRoute
  AppWorkspaceSettingsIntegrationsSupabaseRoute: typeof AppWorkspaceSettingsIntegrationsSupabaseRoute
  AppWorkspaceSettingsAccountIndexRoute: typeof AppWorkspaceSettingsAccountIndexRoute
  AppWorkspaceSettingsIntegrationsIndexRoute: typeof AppWorkspaceSettingsIntegrationsIndexRoute
}

const AppWorkspaceSettingsRouteChildren: AppWorkspaceSettingsRouteChildren = {
  AppWorkspaceSettingsBillingRoute: AppWorkspaceSettingsBillingRoute,
  AppWorkspaceSettingsFrictionRoute: AppWorkspaceSettingsFrictionRoute,
  AppWorkspaceSettingsKnowledgeRoute: AppWorkspaceSettingsKnowledgeRoute,
  AppWorkspaceSettingsMembersRoute: AppWorkspaceSettingsMembersRoute,
  AppWorkspaceSettingsPlansRoute: AppWorkspaceSettingsPlansRoute,
  AppWorkspaceSettingsRiskRoute: AppWorkspaceSettingsRiskRoute,
  AppWorkspaceSettingsSecretsRoute: AppWorkspaceSettingsSecretsRoute,
  AppWorkspaceSettingsTagsRoute: AppWorkspaceSettingsTagsRoute,
  AppWorkspaceSettingsWorkspaceRoute: AppWorkspaceSettingsWorkspaceRoute,
  AppWorkspaceSettingsIndexRoute: AppWorkspaceSettingsIndexRoute,
  AppWorkspaceSettingsAccountApiRoute: AppWorkspaceSettingsAccountApiRoute,
  AppWorkspaceSettingsAccountConnectionsRoute:
    AppWorkspaceSettingsAccountConnectionsRoute,
  AppWorkspaceSettingsAccountPreferencesRoute:
    AppWorkspaceSettingsAccountPreferencesRoute,
  AppWorkspaceSettingsAccountProfileRoute:
    AppWorkspaceSettingsAccountProfileRoute,
  AppWorkspaceSettingsIntegrationsClaudeCodeRoute:
    AppWorkspaceSettingsIntegrationsClaudeCodeRoute,
  AppWorkspaceSettingsIntegrationsGithubRoute:
    AppWorkspaceSettingsIntegrationsGithubRoute,
  AppWorkspaceSettingsIntegrationsLinearRoute:
    AppWorkspaceSettingsIntegrationsLinearRoute,
  AppWorkspaceSettingsIntegrationsMcpSetupRoute:
    AppWorkspaceSettingsIntegrationsMcpSetupRoute,
  AppWorkspaceSettingsIntegrationsNeonRoute:
    AppWorkspaceSettingsIntegrationsNeonRoute,
  AppWorkspaceSettingsIntegrationsSentryRoute:
    AppWorkspaceSettingsIntegrationsSentryRoute,
  AppWorkspaceSettingsIntegrationsSupabaseRoute:
    AppWorkspaceSettingsIntegrationsSupabaseRoute,
  AppWorkspaceSettingsAccountIndexRoute: AppWorkspaceSettingsAccountIndexRoute,
  AppWorkspaceSettingsIntegrationsIndexRoute:
    AppWorkspaceSettingsIntegrationsIndexRoute,
}

const AppWorkspaceSettingsRouteWithChildren =
  AppWorkspaceSettingsRoute._addFileChildren(AppWorkspaceSettingsRouteChildren)

interface AppWorkspaceRouteChildren {
  AppWorkspaceDashboardRoute: typeof AppWorkspaceDashboardRouteWithChildren
  AppWorkspaceSettingsRoute: typeof AppWorkspaceSettingsRouteWithChildren
}

const AppWorkspaceRouteChildren: AppWorkspaceRouteChildren = {
  AppWorkspaceDashboardRoute: AppWorkspaceDashboardRouteWithChildren,
  AppWorkspaceSettingsRoute: AppWorkspaceSettingsRouteWithChildren,
}

const AppWorkspaceRouteWithChildren = AppWorkspaceRoute._addFileChildren(
  AppWorkspaceRouteChildren,
)

interface AppAcceptInviteRouteChildren {
  AppAcceptInviteTokenRoute: typeof AppAcceptInviteTokenRoute
}

const AppAcceptInviteRouteChildren: AppAcceptInviteRouteChildren = {
  AppAcceptInviteTokenRoute: AppAcceptInviteTokenRoute,
}

const AppAcceptInviteRouteWithChildren = AppAcceptInviteRoute._addFileChildren(
  AppAcceptInviteRouteChildren,
)

interface AppAdminImplementationsRouteChildren {
  AppAdminImplementationsIdRoute: typeof AppAdminImplementationsIdRoute
  AppAdminImplementationsIndexRoute: typeof AppAdminImplementationsIndexRoute
}

const AppAdminImplementationsRouteChildren: AppAdminImplementationsRouteChildren =
  {
    AppAdminImplementationsIdRoute: AppAdminImplementationsIdRoute,
    AppAdminImplementationsIndexRoute: AppAdminImplementationsIndexRoute,
  }

const AppAdminImplementationsRouteWithChildren =
  AppAdminImplementationsRoute._addFileChildren(
    AppAdminImplementationsRouteChildren,
  )

interface AppAdminSandboxesRouteChildren {
  AppAdminSandboxesNameRoute: typeof AppAdminSandboxesNameRoute
  AppAdminSandboxesIndexRoute: typeof AppAdminSandboxesIndexRoute
}

const AppAdminSandboxesRouteChildren: AppAdminSandboxesRouteChildren = {
  AppAdminSandboxesNameRoute: AppAdminSandboxesNameRoute,
  AppAdminSandboxesIndexRoute: AppAdminSandboxesIndexRoute,
}

const AppAdminSandboxesRouteWithChildren =
  AppAdminSandboxesRoute._addFileChildren(AppAdminSandboxesRouteChildren)

interface AppAdminWorkflowsRouteChildren {
  AppAdminWorkflowsIdRoute: typeof AppAdminWorkflowsIdRoute
  AppAdminWorkflowsIndexRoute: typeof AppAdminWorkflowsIndexRoute
}

const AppAdminWorkflowsRouteChildren: AppAdminWorkflowsRouteChildren = {
  AppAdminWorkflowsIdRoute: AppAdminWorkflowsIdRoute,
  AppAdminWorkflowsIndexRoute: AppAdminWorkflowsIndexRoute,
}

const AppAdminWorkflowsRouteWithChildren =
  AppAdminWorkflowsRoute._addFileChildren(AppAdminWorkflowsRouteChildren)

interface AppAdminRouteChildren {
  AppAdminImplementationsRoute: typeof AppAdminImplementationsRouteWithChildren
  AppAdminSandboxesRoute: typeof AppAdminSandboxesRouteWithChildren
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppAdminWaitlistRoute: typeof AppAdminWaitlistRoute
  AppAdminWorkflowsRoute: typeof AppAdminWorkflowsRouteWithChildren
  AppAdminIndexRoute: typeof AppAdminIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminImplementationsRoute: AppAdminImplementationsRouteWithChildren,
  AppAdminSandboxesRoute: AppAdminSandboxesRouteWithChildren,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppAdminWaitlistRoute: AppAdminWaitlistRoute,
  AppAdminWorkflowsRoute: AppAdminWorkflowsRouteWithChildren,
  AppAdminIndexRoute: AppAdminIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppGettingStartedRouteChildren {
  AppGettingStartedIndexRoute: typeof AppGettingStartedIndexRoute
}

const AppGettingStartedRouteChildren: AppGettingStartedRouteChildren = {
  AppGettingStartedIndexRoute: AppGettingStartedIndexRoute,
}

const AppGettingStartedRouteWithChildren =
  AppGettingStartedRoute._addFileChildren(AppGettingStartedRouteChildren)

interface AppRouteChildren {
  AppWorkspaceRoute: typeof AppWorkspaceRouteWithChildren
  AppAcceptInviteRoute: typeof AppAcceptInviteRouteWithChildren
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppGettingStartedRoute: typeof AppGettingStartedRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppWorkspaceRoute: AppWorkspaceRouteWithChildren,
  AppAcceptInviteRoute: AppAcceptInviteRouteWithChildren,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppGettingStartedRoute: AppGettingStartedRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  DeviceRoute: DeviceRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  DesktopAuthorizeRoute: DesktopAuthorizeRoute,
  DesktopResetPasswordRoute: DesktopResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
